module.exports = __webpack_public_path__ + "img/NGRECC-logo.86c7a54.png";